import { Directive, Input, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[hours]'
})
export class HoursDirective {

  @Input('hours') dateString: string = '';

  private hours: string = '';

  constructor(private el: ElementRef, private _renderer: Renderer2) { }

  ngOnChanges() {
    let hours = this.dateString.split('T')[1].split('.')[0].split(':');

    this.hours = hours[0] + ':' + hours[1];
    this._renderer.setProperty(this.el.nativeElement, 'innerText', this.hours);
    this._renderer.setProperty(this.el.nativeElement, 'value', this.hours);
  }

}
